// extracted by mini-css-extract-plugin
module.exports = {"sites":"list_sites__Hvc01","categoryBanner":"list_categoryBanner__29lY4"};